import script from "./authOld.vue?vue&type=script&setup=true&lang=js"
export * from "./authOld.vue?vue&type=script&setup=true&lang=js"

import "./authOld.vue?vue&type=style&index=0&id=5d530538&scoped=true&lang=css"

import exportComponent from "F:\\Projetos VueJs\\agenda\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d530538"]])

export default __exports__